import { Play } from "lucide-react";

const VideoWelcome = () => {
  return (
    <section className="py-16 bg-black">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">
            Meet Your Crypto Yield Coach
          </h2>
          
          <div className="relative bg-muted rounded-lg overflow-hidden mb-8 aspect-video max-w-3xl mx-auto">
            {/* Video placeholder - will be replaced with actual video */}
            <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-primary/10 to-primary/20">
              <div className="text-center">
                <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center mb-4 mx-auto hover:bg-primary/90 transition-colors cursor-pointer">
                  <Play className="w-8 h-8 text-primary-foreground ml-1" />
                </div>
                <p className="text-muted-foreground">Video will be added here</p>
              </div>
            </div>
          </div>
          
          <div className="space-y-4 text-lg text-muted-foreground max-w-2xl mx-auto">
            <p>
              Hi! I'm excited to personally welcome you to this exclusive workshop where I'll show you 
              exactly how I've been generating consistent 1% daily returns using automated gridbot strategies.
            </p>
            <p>
              This isn't theory – it's a proven system that's been working for me and my students. 
              In the next few minutes, you'll discover how to turn crypto's daily volatility into 
              your reliable monthly income stream.
            </p>
            <p className="text-foreground font-medium">
              Ready to learn the gridbot system that could change your financial future?
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoWelcome;